export const profitabilityOptions = [
    { key: 'M', label: '< 35%' },
    { key: 'A', label: '35 - 75%' },
    { key: 'B', label: '75 - 150%' },
    { key: 'C', label: '150 - 400%' },
    { key: 'D', label: '> 400%' }
];

export const timingOptions = [
    { key: 'monthly', label: 'Mensual' },
    { key: 'ipo', label: 'IPO' }
];

export const directionOptions = [
    { key: 'bearish', label: 'Bajista' },
    { key: 'bullish', label: 'Alcista' }
];

export const entryTypeOptions = [
    { key: 'per', label: 'PER' },
    { key: 'rr', label: 'RR' },
    { key: 'rra', label: 'RRA' },
    { key: 'lt', label: 'LT' },
    { key: 'lta', label: 'LTA' },
    { key: 'se', label: 'SE' }
];

export const valueTypeOptions = [
    { key: 'Stock', label: 'Stock' },
    { key: 'ETF', label: 'ETF' }
];

export const dividendOptions = [
    { key: 'zero', label: '0' },
    { key: 'one', label: '1' },
    { key: 'two', label: '2' },
    { key: 'threePlus', label: '3+' }
];

export const entryDistanceOptions = [
    { value: '', label: 'Sin limite' },
    { value: '0', label: '0%' },
    { value: '1', label: '1%' },
    { value: '2', label: '2%' },
    { value: '3', label: '3%' },
    { value: '4', label: '4%' },
    { value: '5', label: '5%' },
    { value: '10', label: '10%' },
    { value: '15', label: '15%' },
    { value: '20', label: '20%' },
    { value: '25', label: '25%+' }
];

export const ageOptions = [
    { value: '', label: 'Sin limite' },
    { value: '1', label: '1 ano' },
    { value: '2', label: '2 anos' },
    { value: '3', label: '3 anos' },
    { value: '4', label: '4 anos' },
    { value: '5', label: '5 anos' },
    { value: '6', label: '6 anos' },
    { value: '7', label: '7 anos' },
    { value: '8', label: '8 anos' },
    { value: '9', label: '9 anos' },
    { value: '10', label: '10 anos' },
    { value: '15', label: '15 anos' },
    { value: '20', label: '20 anos' }
];
